import { Effect, Layer, Option } from 'effect'
import JSCookies from 'js-cookie'

import { CookieStore } from '@viziertronic/cookie-store'

const BrowserCookieStore = CookieStore.of({
  get: (name) => Effect.succeed(Option.fromNullishOr(JSCookies.get(name))),
  set: (name, value, options) =>
    Effect.sync(() => {
      JSCookies.set(name, value, {
        expires: options.expires,
        maxAge: options.maxAge,
        path: options.path,
        domain: options.domain,
        secure: options.secure,
        httpOnly: options.httpOnly,
        sameSite: options.sameSite,
        partitioned: options.partitioned,
      })
    }),
  delete: (name) => Effect.sync(() => JSCookies.remove(name)),
})

export const BrowserCookieStoreLayer = Layer.succeed(
  CookieStore,
  BrowserCookieStore,
)
